import { OptionType } from './type';

/**
 * 根据values值获取对应全部的options数组
 * @param value 传入的所有值 [value1, value2, value3]
 * @param options  值依次对应的选项列表  [option1, option2, option3]
 */
export const getOptionsWithValues = (value?: Array<OptionType['value']>, options?: OptionType[]): OptionType[] => {
    if (value?.length && options?.length) {
        const opt = options.find(item => item.value === value[0]);

        if (opt) {
            return [opt, ...getOptionsWithValues(value.slice(1), opt.options)];
        }
    }

    return [];
};

/**
 * 根据value值获取显示的label
 * @param value 值数据
 * @param options 原始options
 */
export function getLabelsWithValues(value?: Array<OptionType['value']>, options?: OptionType[]) {
    const opts = getOptionsWithValues(value, options);

    return getLabelsWithSelectedOptions(opts);
}

/**
 * 获取selectedOptions的label数组
 */
export function getLabelsWithSelectedOptions(selectedOptions: OptionType[]) {
    return selectedOptions.map(item => item.label);
}
